import React from 'react'
import CustomCursor from '../../Global/Cursor'
import Preloader from '../../Global/Preloader'
import Header from '../../Global/Header1'
import PageInear from '../MenShop/PageInear'
import Shop from '../MenShop/Shop'
import Cta from '../MenShop/Cta'
import Footer from '../../Global/Footer1'
import GoToTop from '../../Global/GoToTop'
const Main = () => {
    return (
        <>
            <CustomCursor />
            <Preloader />
            <Header />
            <PageInear />
            <Shop />
            <Cta />
            <Footer />
            <GoToTop />
        </>
    )
}

export default Main
